export enum UserProfileTypes {
    None = "None",
    Volunteer = "Volunteer",
    VolunteerGroup = "Volunteer Group",
    Nonprofit = "Nonprofit",
    ForProfit = "For-Profit"
};